export interface WebStorageServiceOptions {
    namespace: string
}

export interface WebStorageServiceInterface {
    set(name: string, value: any, expireInSeconds?: number): void

    get(name: string, defaultValue?: any): any

    key(index: number): null | string

    remove(name: string): void

    clear(): void

    getExpire(name: string): number | null

    setOptions(options: WebStorageServiceOptions): void
}

export class WebStorageService implements WebStorageServiceInterface {

    #storage: Storage;
    #options: WebStorageServiceOptions;

    constructor(storage: Storage, options: WebStorageServiceOptions) {
        this.#storage = storage;
        this.#options = options;
    }

    get length(): number {

        return this.#storage.length;
    }

    set(name: string, value: any, expireInSeconds?: number): void {

        const stringifyValue: string = JSON.stringify({
            value,
            expire: expireInSeconds ? new Date().getTime() + expireInSeconds * 1000 : null,
        });

        this.#storage.setItem(this.#options.namespace + name, stringifyValue);
    }

    get(name: string, defaultValue: any = null): any {

        const item: string | null = this.#storage.getItem(this.#options.namespace + name);

        if (item !== null) {
            try {
                const data = JSON.parse(item);

                if (!data.expire) {
                    return data.value;
                }

                if (data.expire >= new Date().getTime()) {
                    return data.value;
                }

                this.remove(name);
            } catch (err) {

                return defaultValue;
            }
        }

        return defaultValue;
    }

    remove(name: string): void {

        this.#storage.removeItem(this.#options.namespace + name);
    }

    key(index: number): null | string {

        return this.#storage.key(index);
    }

    clear(): void {

        if (this.length) {

            const keys = [];

            for (let i: number = 0; i < this.length; i++) {
                const key: null | string = this.#storage.key(i);

                if (key) {
                    const regexp = new RegExp(`^${this.#options.namespace}.+`, 'i');

                    if (regexp.test(key)) {
                        keys.push(key);
                    }
                }
            }

            for (const key in keys) {
                this.#storage.removeItem(keys[key]);
            }
        }
    }

    getExpire(name: string): null | number {

        const item: string | null = this.#storage.getItem(this.#options.namespace + name);

        if (item !== null) {

            try {
                const data = JSON.parse(item);

                if (data.expire) {

                    return data.expire as number;
                }
            } catch (err) {
            }
        }

        return null;
    }

    setOptions(options: WebStorageServiceOptions): void {

        this.#options = options;
    }
}